import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '../env';
import { getLocalStorage } from '../utils/function/localStorage';

export const spinWheelApi = createApi({
  reducerPath: 'spinWheelApi',
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    prepareHeaders: (headers) => {
      // Aligning with quizApi, directly setting X-Auth-Token from localStorage
      headers.set('X-Auth-Token', getLocalStorage('tp_Aa_uth_access'));
      return headers;
    },
  }),
  tagTypes: ['LeaderBoard', 'SpinWheelConfig'],

  endpoints: (builder) => ({
    spinWheelClaimDynamic: builder.mutation({
      query: (body) => ({
        url: '/secure/spinWheelClaimDynamic',
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['LeaderBoard'],
    }),

    spinCountTodayDynamic: builder.query({
      query: () => `/secure/spinCountTodayDynamic`,
      providesTags: ["LeaderBoard"],
    }),

    buyReferralSpin: builder.mutation({
      query: (body) => ({
        url: '/secure/buyReferralSpin',
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['LeaderBoard'],
    }),

    buyReferralSpinCountToday: builder.query({
      query: () => `/secure/buyReferralSpinCountToday`,
      providesTags: ["LeaderBoard"],
    }),

    getSpinWheelConfig: builder.query({
      query: () => '/secure/spinWheelConfig',
      providesTags: ['SpinWheelConfig'],
    }),
  }),
});

export const {
  useSpinWheelClaimDynamicMutation,
  useSpinCountTodayDynamicQuery,
  useBuyReferralSpinMutation,
  useBuyReferralSpinCountTodayQuery,
  useGetSpinWheelConfigQuery,
} = spinWheelApi;
